import { Component, OnDestroy, OnInit } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { AccessControlService } from "../../app/access-control/access-control-service";
import { AuthService } from "../../app/auth/auth.service";
import { StateManagementService } from "../../providers/state-management/state-management.service";
import { UsersService } from "../../providers/users-service/users.service";
import { BasePage } from "../base-page";
import { CompanyManagementPage } from "./company-management/company-management";

@IonicPage()
@Component({
  selector: "company",
  templateUrl: "company.html",
})
export class CompanyPage extends BasePage implements OnDestroy, OnInit {
  rootPage: CompanyManagementPage;

  constructor(
    protected accessControlService: AccessControlService,
    protected navCtrl: NavController,
    protected navParams: NavParams,
    protected userService: UsersService,
    protected stateManagementService: StateManagementService,
    protected authSvc: AuthService
  ) {
    super(stateManagementService);
  }

  ionViewDidLoad() {
    this.stateManagementService.setAssessmentType("company");
    this.stateManagementService.setSectionId("company");
  }

  ionViewCanEnter() {
    return this.authSvc.authenticated();
  }

  navigate(entity: string) {
    this.navCtrl.push("CompanyManagementPage");
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/pages/company/company.ts